import { AppTile } from './app-tile';

export class UserAppTile {
  public UserUpnId: string;
  public AppTile: AppTile;
  public AppTileId: number;
  public HideFromUI: boolean;
  public ChannelSubscribed: boolean;
  public Order: number;
  public ShowNewOrModifiedBadge: boolean;

  constructor(opt?: Partial<UserAppTile>) {
    if (opt) {
      if (opt.AppTile && opt.AppTile.ShowAsNewUntilThisDate && typeof opt.AppTile.ShowAsNewUntilThisDate === 'string') {
        opt.AppTile = new AppTile(opt.AppTile);
      }
    }

    Object.assign(this, opt);
  }
}
